export default __webpack_public_path__ + "static/media/explanation.1903259b.png";